import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view"
import {QUICK_FILTER_ALL_VALUES} from "../../../../gd/const/quick-filter"

const debug = false
// const debug = "FieldRAG_QuickFilterView"

export default function FieldRAG_QuickFilterView(props: FieldQuickFilterViewProps) {
    const {value} = props

    debug && console.log(debug, 'render', value, typeof value)

    switch (value) {
        case QUICK_FILTER_ALL_VALUES:    return <div className="name">All values</div>

        default:
            const ragValue = typeof value === 'string' ? parseInt(value) : value

            const classes = Classes("ui5-ico-rag lh-20", {
                'red'   : ragValue === 0,
                'amber' : ragValue === 1,
                'green' : ragValue === 2,
            })

            return <div className={classes}/>
    }
}